module.exports = __webpack_public_path__ + "img/mobile-background.dd9d6d14.png";